export default __webpack_public_path__ + "static/media/020_start.last.52e36e99.avif";